export default "__VITE_ASSET__CBDJDoqh__"